import type { FeatureCollection, Polygon } from 'geojson';

type CnpGeoJsonProperties = { Name: string };
type CnpCriticalInfraGeoJson = FeatureCollection<Polygon, CnpGeoJsonProperties> & { name: string };

// duplicated in packages/api/src/assets/geojson/cnpCriticalInfrastructure.ts
export const criticalInfraGeoJson: CnpCriticalInfraGeoJson = {
  type: 'FeatureCollection',
  name: 'Critical Infrastructure Areas',
  features: [
    {
      type: 'Feature',
      properties: {
        Name: 'IAH - Airport ',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-95.3499362, 29.9539288],
            [-95.32357, 29.9540472],
            [-95.3357981, 29.9744186],
            [-95.3003103, 29.9749985],
            [-95.3057672, 29.9839417],
            [-95.3091323, 30.0090428],
            [-95.3742893, 30.0109338],
            [-95.3499362, 29.9539288],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Houston Hobby - Airport',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-95.288621, 29.6348005],
            [-95.2661461, 29.6344865],
            [-95.2628443, 29.6582161],
            [-95.2890291, 29.6576789],
            [-95.288621, 29.6348005],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'NRG - Stadium',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-95.4127105, 29.6891045],
            [-95.4121366, 29.6785226],
            [-95.403262, 29.6792547],
            [-95.4036339, 29.689134],
            [-95.4127105, 29.6891045],
          ],
        ],
      },
      id: 2,
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Toyota Center - Stadium',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-95.3635047, 29.7507272],
            [-95.361861, 29.7497592],
            [-95.3606927, 29.7510666],
            [-95.3623312, 29.7520798],
            [-95.3635047, 29.7507272],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'George R Brown - Convention Center',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-95.3600334, 29.7507132],
            [-95.3587384, 29.7499257],
            [-95.3556497, 29.7536042],
            [-95.3572072, 29.7544464],
            [-95.3600334, 29.7507132],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Daikin Park - Stadium',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-95.3569753, 29.7567916],
            [-95.3546148, 29.7555581],
            [-95.352729, 29.7573632],
            [-95.355556, 29.7589659],
            [-95.3569753, 29.7567916],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Texas Medical Center - Hospital Area',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-95.3965924, 29.7158275],
            [-95.4160064, 29.692077],
            [-95.3928329, 29.6920783],
            [-95.3931738, 29.6975297],
            [-95.3757118, 29.7008558],
            [-95.3790909, 29.7129793],
            [-95.3965924, 29.7158275],
          ],
        ],
      },
      id: 6,
    },
  ],
};
